"use strict";

var _defineProperty = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/defineProperty");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatNumber = exports.PRESET_FORMATS = void 0;
exports.PRESET_FORMATS = {
  number: {
    maximumFractionDigits: 0
  },
  decimal: {
    style: 'decimal',
    maximumFractionDigits: 2
  },
  abbreviated: {
    notation: 'compact',
    compactDisplay: 'short'
  },
  currency: {
    "extends": 'number',
    style: 'currency',
    currency: 'USD'
  },
  decimalCurrency: {
    "extends": ['currency', 'decimal'],
    style: 'currency'
  },
  abbreviatedCurrency: {
    "extends": 'abbreviated',
    style: 'currency',
    currency: 'USD'
  },
  accounting: {
    "extends": 'decimalCurrency',
    currencySign: 'accounting'
  },
  percentage: {
    style: 'percent'
  },
  decimalPercentage: {
    "extends": ['decimal', 'percentage']
  }
};

function _resolveConfig(config) {
  if (config["extends"]) {
    var arrayExtends = Array.isArray(config["extends"]) ? config["extends"] : [config["extends"]];
    var finalConfig = arrayExtends.reduce(function (acc, ext) {
      var extendsConfig = _resolveConfig(exports.PRESET_FORMATS[ext]);

      if (!extendsConfig) {
        throw new Error("Extends preset: '".concat(ext, "' is invalid."));
      }

      return Object.assign(Object.assign({}, acc), extendsConfig);
    }, {});
    return Object.assign(Object.assign({}, finalConfig), config);
  } else return config;
} // Re-use the instances for performance: https://blog.david-reess.de/posts/hBEx9w-on-number-formatting-and-performance


var PRESET_INSTANCES = Object.keys(exports.PRESET_FORMATS).reduce(function (acc, format) {
  return Object.assign(Object.assign({}, acc), _defineProperty({}, format, new Intl.NumberFormat(undefined, _resolveConfig(exports.PRESET_FORMATS[format]))));
}, {});

function formatNumber(number, format) {
  if (number !== undefined && number !== null) {
    if (typeof format === 'string') {
      if (!PRESET_INSTANCES[format]) {
        throw new Error("Format preset: '".concat(format, "' is invalid."));
      }

      return PRESET_INSTANCES[format].format(number);
    } else {
      // This is not as performant as the route above.
      return new Intl.NumberFormat(undefined, _resolveConfig(format)).format(number);
    }
  } else return null;
}

exports.formatNumber = formatNumber;